export default __webpack_public_path__ + "static/media/cancel-blue.8a2978e9.svg";